import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var wrapper = 'fx_2d2fb1e5_14nfu950';
var yearButton = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_14nfu952',variantClassNames:{isRangeStartDate:{true:'fx_2d2fb1e5_14nfu953'},isRangeEndDate:{true:'fx_2d2fb1e5_14nfu954'},isInRange:{true:'fx_2d2fb1e5_14nfu955'}},defaultVariants:{},compoundVariants:[[{isRangeStartDate:true,isRangeEndDate:true},'fx_2d2fb1e5_14nfu956'],[{isInRange:true,isRangeStartDate:false,isRangeEndDate:false},'fx_2d2fb1e5_14nfu957']]});
var yearHeader = 'fx_2d2fb1e5_14nfu951';

export { wrapper, yearButton, yearHeader };
//# sourceMappingURL=yearCalendar.vanilla.mjs.map
